import { render, staticRenderFns } from "./ThgSuccess.vue?vue&type=template&id=1b46963e&scoped=true"
import script from "./ThgSuccess.vue?vue&type=script&lang=ts"
export * from "./ThgSuccess.vue?vue&type=script&lang=ts"
import style0 from "./ThgSuccess.vue?vue&type=style&index=0&id=1b46963e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46963e",
  null
  
)

export default component.exports